import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Button, Dialog, Grid, List, ListItem, ListItemText, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import ListaRegraValidacao from 'esocial.web.react.lib/cjs/components/form/Validation/ListaRegraValidacao';
import RegraCaepf from 'esocial.web.react.lib/cjs/components/form/Validation/RegraCaepf';
import RegraCno from 'esocial.web.react.lib/cjs/components/form/Validation/RegraCno';
import RegraCnpj from 'esocial.web.react.lib/cjs/components/form/Validation/RegraCnpj';
import RegraObrigatoriedade from 'esocial.web.react.lib/cjs/components/form/Validation/RegraObrigatoriedade';
import { VepSelect } from 'esocial.web.react.lib/cjs/components/form/Vep/VepSelect';
import { VepTextField } from 'esocial.web.react.lib/cjs/components/form/Vep/VepTextField';
import { CustomDialogActions, CustomDialogContent, CustomDialogTitle } from 'esocial.web.react.lib/cjs/components/util/Dialog';
import { Display } from 'esocial.web.react.lib/cjs/components/util/Display';
import { Fieldset } from 'esocial.web.react.lib/cjs/components/util/Fieldset';
import { CustomTable } from 'esocial.web.react.lib/cjs/components/util/Table';
import { useAppDispatch } from 'esocial.web.react.lib/cjs/hooks/Reduz';
import { abrirModalConfirmacao, fecharModalConfirmacao } from "esocial.web.react.lib/cjs/store/reducers/modais";
import { TipoInscricao } from 'esocial.web.react.lib/cjs/utils/enums';
import { calcularHashDeString, getStringValue, obterMascaraPorTipoInscricao, obterObjetoTodosComponentesIntocados, obterObjetoTodosComponentesTocados, retornarFocoParaBotaoChamador, rolarVisualizacaoAteElementoInvalido, verificarTodosComponentesTocados } from 'esocial.web.react.lib/cjs/utils/geral';
import { Fragment, useEffect, useRef, useState } from 'react';

const ContainerBotoesTabelaAcao = styled(TableCell)(({ theme }) => ({
    '& > *': {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
}));

const ButtonTextPrimary = styled(IconButton)(({ theme }) => ({
    color: theme.palette.text.primary,
}));

const CnpjAlfanumerico = styled(VepTextField)(() => ({
    '& input': {
        fontFamily: 'monospace'
    }
}));

function calcularHashItem(item) {
    return calcularHashDeString(`${item.localAmbiente}${item.descricaoSetor}${item.tipoInscricao}${item.numeroInscricao}`);
}

const chaveNovoItem = 'n';
const sufixoChaveExcluirItem = '_e';

function AmbientesTrabalho(props) {
    // Trecho reservado para ajuste no retorno da modal de inserir/editar item
    const action = useRef(null);
    const ref = useRef(null);

    const [chaveActionRefAtual, setChaveActionRefAtual] = useState(null);
    // Fim de Trecho reservado para ajuste no retorno da modal de inserir/editar item

    const [habilitarEdicaoAtualizacao, setHabilitarEdicaoAtualizacao] = useState(false);
    const [habilitarInsercaoAtualizacao, setHabilitarInsercaoAtualizacao] = useState(false);
    const [habilitarVisualizacao, setHabilitarVisualizacao] = useState(false);

    const dispatch = useAppDispatch();

    function excluirItem(indice, hashExclusao) {
        const modalConfirmacaoProps = {
            texto: 'Tem certeza que deseja excluir "Ambiente de Trabalho"?',
            textoBotaoNao: 'Não',
            textoBotaoSim: 'Sim',
            actionBotaoNao: () => {
                setChaveActionRefAtual(hashExclusao);
                retornarFocoParaBotaoChamador(action, ref);
                dispatch(fecharModalConfirmacao());
            },
            actionBotaoSim: async () => {
                props.setModelo({
                    ...props.modelo, listaAmbientesTrabalho: props.modelo.listaAmbientesTrabalho.filter((l) => l !== props.modelo.listaAmbientesTrabalho[indice])
                });

                // Ao excluir um item, retornar o foco ao botão de inclusão de novo item
                setChaveActionRefAtual(chaveNovoItem);
                retornarFocoParaBotaoChamador(action, ref);
            }
        };

        dispatch(abrirModalConfirmacao(modalConfirmacaoProps));
    }

    // Estado de campos ainda não tocados pelo usuário e formulário ainda não submetido (usado no mecanismo de validações)
    const objetoComponentesTocados = {};

    objetoComponentesTocados['itemAmbienteTrabalhoAuxiliar.localAmbiente'] = false;
    objetoComponentesTocados['itemAmbienteTrabalhoAuxiliar.descricaoSetor'] = false;
    objetoComponentesTocados['itemAmbienteTrabalhoAuxiliar.tipoInscricaoAmbiente'] = false;
    objetoComponentesTocados['itemAmbienteTrabalhoAuxiliar.numeroInscricaoAmbiente'] = false;

    const [componenteTocadoFormulario, setComponenteTocadoFormulario] = useState(objetoComponentesTocados);

    // Construção das regras de validação para os campos do formulário
    const [regraValidacaoFormulario, setRegraValidacaoFormulario] = useState({});

    useEffect(() => {
        const objetoRegrasValidacao = {};

        if (props.modelo != null) {
            objetoRegrasValidacao['itemAmbienteTrabalhoAuxiliar.localAmbiente'] = new RegraObrigatoriedade(props.modelo.itemAmbienteTrabalhoAuxiliar.localAmbiente.valor, componenteTocadoFormulario['itemAmbienteTrabalhoAuxiliar.localAmbiente']);
            objetoRegrasValidacao['itemAmbienteTrabalhoAuxiliar.descricaoSetor'] = new RegraObrigatoriedade(props.modelo.itemAmbienteTrabalhoAuxiliar.descricaoSetor.valor, componenteTocadoFormulario['itemAmbienteTrabalhoAuxiliar.descricaoSetor']);
            objetoRegrasValidacao['itemAmbienteTrabalhoAuxiliar.tipoInscricaoAmbiente'] = new RegraObrigatoriedade(props.modelo.itemAmbienteTrabalhoAuxiliar.tipoInscricaoAmbiente.valor, componenteTocadoFormulario['itemAmbienteTrabalhoAuxiliar.tipoInscricaoAmbiente']);
            objetoRegrasValidacao['itemAmbienteTrabalhoAuxiliar.numeroInscricaoAmbiente'] = new ListaRegraValidacao([new RegraObrigatoriedade(props.modelo.itemAmbienteTrabalhoAuxiliar.numeroInscricaoAmbiente.valor), new RegraCnpj(props.modelo.itemAmbienteTrabalhoAuxiliar.numeroInscricaoAmbiente.valor, parseInt(props.modelo.itemAmbienteTrabalhoAuxiliar.tipoInscricaoAmbiente.valor) === TipoInscricao.CNPJ), new RegraCaepf(props.modelo.itemAmbienteTrabalhoAuxiliar.numeroInscricaoAmbiente.valor, parseInt(props.modelo.itemAmbienteTrabalhoAuxiliar.tipoInscricaoAmbiente.valor) === TipoInscricao.CAEPF), new RegraCno(props.modelo.itemAmbienteTrabalhoAuxiliar.numeroInscricaoAmbiente.valor, parseInt(props.modelo.itemAmbienteTrabalhoAuxiliar.tipoInscricaoAmbiente.valor) === TipoInscricao.CNO)], componenteTocadoFormulario['itemAmbienteTrabalhoAuxiliar.numeroInscricaoAmbiente']);
            objetoRegrasValidacao.todosComponentesTocados = verificarTodosComponentesTocados(componenteTocadoFormulario);
        }

        setRegraValidacaoFormulario(objetoRegrasValidacao);
    }, [props.modelo, componenteTocadoFormulario]);

    const [nomeFuncaoAcaoFormularioCompletamenteValidado, setNomeFuncaoAcaoFormularioCompletamenteValidado] = useState(null);

    useEffect(() => {
        const valoresValidacaoFormulario = Object.values(regraValidacaoFormulario).filter((x) => typeof x !== 'boolean');

        if (regraValidacaoFormulario.todosComponentesTocados) {
            if (typeof nomeFuncaoAcaoFormularioCompletamenteValidado === 'string' && valoresValidacaoFormulario.length > 0) {
                if (!new ListaRegraValidacao(valoresValidacaoFormulario).existeErro()) {
                    if (nomeFuncaoAcaoFormularioCompletamenteValidado === 'inserirItem') {
                        inserirItem();
                    }
                    else if (nomeFuncaoAcaoFormularioCompletamenteValidado === 'editarItem') {
                        editarItem();
                    }

                    retornarFocoParaBotaoChamador(action, ref);
                }
                else {
                    rolarVisualizacaoAteElementoInvalido('modalAmbientesTrabalho');
                }
            }

            setNomeFuncaoAcaoFormularioCompletamenteValidado(null);
        }

    }, [nomeFuncaoAcaoFormularioCompletamenteValidado, regraValidacaoFormulario.todosComponentesTocados]);

    const habilitarEdicaoItem = () => {
        setHabilitarEdicaoAtualizacao(true);
    };

    const habilitarVisualizacaoItem = () => {
        setHabilitarVisualizacao(true);
    };

    function cancelar() {
        setHabilitarEdicaoAtualizacao(false);
        setHabilitarInsercaoAtualizacao(false);
        setHabilitarVisualizacao(false);

        // Limpar os valores dos campos auxiliares
        props.setModelo({
            ...props.modelo,
            itemAmbienteTrabalhoAuxiliar: {
                localAmbiente: { ...props.modelo.itemAmbienteTrabalhoAuxiliar.localAmbiente, valor: null },
                descricaoSetor: { ...props.modelo.itemAmbienteTrabalhoAuxiliar.descricaoSetor, valor: null },
                tipoInscricaoAmbiente: { ...props.modelo.itemAmbienteTrabalhoAuxiliar.tipoInscricaoAmbiente, valor: null },
                numeroInscricaoAmbiente: { ...props.modelo.itemAmbienteTrabalhoAuxiliar.numeroInscricaoAmbiente, valor: null }
            }
        });

        retornarFocoParaBotaoChamador(action, ref);
    }

    const novoItem = () => {
        setComponenteTocadoFormulario(obterObjetoTodosComponentesIntocados(componenteTocadoFormulario));
        setHabilitarInsercaoAtualizacao(true);
        setChaveActionRefAtual(chaveNovoItem);
    };

    function inserirItem() {
        const itemLista = {
            localAmbiente: props.modelo.itemAmbienteTrabalhoAuxiliar.localAmbiente.valor,
            descricaoSetor: props.modelo.itemAmbienteTrabalhoAuxiliar.descricaoSetor.valor,
            tipoInscricao: props.modelo.itemAmbienteTrabalhoAuxiliar.tipoInscricaoAmbiente.valor,
            numeroInscricao: props.modelo.itemAmbienteTrabalhoAuxiliar.numeroInscricaoAmbiente.valor
        };

        props.setModelo({
            ...props.modelo, listaAmbientesTrabalho: [...props.modelo.listaAmbientesTrabalho, itemLista],
            itemAmbienteTrabalhoAuxiliar: {
                localAmbiente: { ...props.modelo.itemAmbienteTrabalhoAuxiliar.localAmbiente, valor: null },
                descricaoSetor: { ...props.modelo.itemAmbienteTrabalhoAuxiliar.descricaoSetor, valor: null },
                tipoInscricaoAmbiente: { ...props.modelo.itemAmbienteTrabalhoAuxiliar.tipoInscricaoAmbiente, valor: null },
                numeroInscricaoAmbiente: { ...props.modelo.itemAmbienteTrabalhoAuxiliar.numeroInscricaoAmbiente, valor: null }
            }
        });

        setHabilitarInsercaoAtualizacao(false);
    }

    function copiarItem(indice, somenteLeitura, hash) {
        if (somenteLeitura) {
            habilitarVisualizacaoItem();
        } else {
            habilitarEdicaoItem();
        }

        props.setModelo({
            ...props.modelo,
            itemAmbienteTrabalhoAuxiliar: {
                chave: indice,
                localAmbiente: { ...props.modelo.itemAmbienteTrabalhoAuxiliar.localAmbiente, valor: props.modelo.listaAmbientesTrabalho[indice].localAmbiente },
                descricaoSetor: { ...props.modelo.itemAmbienteTrabalhoAuxiliar.descricaoSetor, valor: props.modelo.listaAmbientesTrabalho[indice].descricaoSetor },
                tipoInscricaoAmbiente: { ...props.modelo.itemAmbienteTrabalhoAuxiliar.tipoInscricaoAmbiente, valor: props.modelo.listaAmbientesTrabalho[indice].tipoInscricao },
                numeroInscricaoAmbiente: { ...props.modelo.itemAmbienteTrabalhoAuxiliar.numeroInscricaoAmbiente, valor: props.modelo.listaAmbientesTrabalho[indice].numeroInscricao }
            }
        });

        setChaveActionRefAtual(hash);
    }

    function editarItem() {
        const itemLista = {
            localAmbiente: props.modelo.itemAmbienteTrabalhoAuxiliar.localAmbiente.valor,
            descricaoSetor: props.modelo.itemAmbienteTrabalhoAuxiliar.descricaoSetor.valor,
            tipoInscricao: props.modelo.itemAmbienteTrabalhoAuxiliar.tipoInscricaoAmbiente.valor,
            numeroInscricao: props.modelo.itemAmbienteTrabalhoAuxiliar.numeroInscricaoAmbiente.valor
        };

        // Nesse ponto sabemos que o item pôde ser editado e chave para localização do botão com action e ref
        // de destino do foco deve ser recalculado em termos dos componentes do item
        const hash = calcularHashItem(itemLista);
        setChaveActionRefAtual(hash);

        let chaveAlteracao = props.modelo.itemAmbienteTrabalhoAuxiliar.chave;

        props.setModelo({
            ...props.modelo, listaAmbientesTrabalho: [...props.modelo.listaAmbientesTrabalho.filter((l) => l !== props.modelo.listaAmbientesTrabalho[chaveAlteracao]), itemLista],
            itemAmbienteTrabalhoAuxiliar: {
                localAmbiente: { ...props.modelo.itemAmbienteTrabalhoAuxiliar.localAmbiente, valor: null },
                descricaoSetor: { ...props.modelo.itemAmbienteTrabalhoAuxiliar.descricaoSetor, valor: null },
                tipoInscricaoAmbiente: { ...props.modelo.itemAmbienteTrabalhoAuxiliar.tipoInscricaoAmbiente, valor: null },
                numeroInscricaoAmbiente: { ...props.modelo.itemAmbienteTrabalhoAuxiliar.numeroInscricaoAmbiente, valor: null }
            }
        });

        setHabilitarEdicaoAtualizacao(false);
    }

    function atualizarItem() {
        setComponenteTocadoFormulario(obterObjetoTodosComponentesTocados(componenteTocadoFormulario));
        setNomeFuncaoAcaoFormularioCompletamenteValidado(habilitarEdicaoAtualizacao ? 'editarItem' : 'inserirItem');
    }

    function handleChangeNumeroInscricaoAmbiente(e) {
        props.setModelo({
            ...props.modelo,
            itemAmbienteTrabalhoAuxiliar: {
                ...props.modelo.itemAmbienteTrabalhoAuxiliar,
                numeroInscricaoAmbiente: { ...props.modelo.itemAmbienteTrabalhoAuxiliar.numeroInscricaoAmbiente, valor: getStringValue(e.target.value).toUpperCase() }
            }
        });
    }

    return (
        (props.modelo !== null && Object.values(regraValidacaoFormulario).length > 0) &&
        <Fragment>
            <Fieldset legend="Ambientes de trabalho" spacing={4}>
                <Display show={!props.somenteVisualizacao}>
                    <Grid item style={{ flexBasis: '100%', paddingTop: '0.3rem' }}>
                        <Button color="primary"
                            startIcon={<AddIcon />}
                            onClick={() => novoItem()}
                            disabled={habilitarInsercaoAtualizacao || habilitarEdicaoAtualizacao}
                            action={chaveActionRefAtual === chaveNovoItem ? action : undefined}
                            ref={chaveActionRefAtual === chaveNovoItem ? ref : undefined}
                        >
                            Incluir Ambiente de trabalho
                        </Button>
                    </Grid>
                </Display>

                <Display show={props.modelo.listaAmbientesTrabalho.length > 0}>
                    <Grid item style={{ flexBasis: '100%' }}>
                        <CustomTable>
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center">Ambiente de Trabalho</TableCell>
                                    <TableCell align="center">Ação</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {props.modelo.listaAmbientesTrabalho.map((linha, indice) => {
                                    const hash = calcularHashItem(linha);
                                    const hashExclusao = `${hash}${sufixoChaveExcluirItem}`;

                                    return (
                                        <TableRow key={indice}>
                                            <TableCell align="center">{linha.descricaoSetor}</TableCell>

                                            <ContainerBotoesTabelaAcao align="center">
                                                <Display show={props.somenteVisualizacao}>
                                                    <ButtonTextPrimary
                                                        color="inherit"
                                                        size="small"
                                                        aria-label="visualizar item"
                                                        onClick={() => copiarItem(indice, true, hash)}
                                                        action={chaveActionRefAtual === hash ? action : undefined}
                                                        ref={chaveActionRefAtual === hash ? ref : undefined}
                                                    >
                                                        <VisibilityIcon fontSize="small" />
                                                    </ButtonTextPrimary>
                                                </Display>
                                                <Display show={!props.somenteVisualizacao}>
                                                    <ButtonTextPrimary
                                                        color="inherit"
                                                        size="small"
                                                        aria-label="editar item"
                                                        onClick={() => copiarItem(indice, false, hash)}
                                                        disabled={habilitarInsercaoAtualizacao || habilitarEdicaoAtualizacao}
                                                        action={chaveActionRefAtual === hash ? action : undefined}
                                                        ref={chaveActionRefAtual === hash ? ref : undefined}
                                                    >
                                                        <EditIcon fontSize="small" />
                                                    </ButtonTextPrimary>
                                                    <IconButton
                                                        color="inherit"
                                                        size="small"
                                                        aria-label="excluir item"
                                                        onClick={() => excluirItem(indice, hashExclusao)}
                                                        disabled={habilitarInsercaoAtualizacao || habilitarEdicaoAtualizacao}
                                                        action={chaveActionRefAtual === hashExclusao ? action : undefined}
                                                        ref={chaveActionRefAtual === hashExclusao ? ref : undefined}
                                                    >
                                                        <DeleteIcon fontSize="small" />
                                                    </IconButton>
                                                </Display>
                                            </ContainerBotoesTabelaAcao>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </CustomTable>
                    </Grid>
                </Display>

                <Display show={props.modelo.listaAmbientesTrabalho.length < 1}>
                    <Grid item style={{ flexBasis: '100%' }}>
                        <Typography>Nenhum ambiente de trabalho cadastrado</Typography>
                    </Grid>
                </Display>
            </Fieldset>

            {/*Modal para inserção/edição de ambiente de trabalho*/}
            <Dialog
                open={(habilitarInsercaoAtualizacao || habilitarEdicaoAtualizacao) && !props.somenteVisualizacao}
                onClose={() => { cancelar() }}
                aria-labelledby="form-dialog-title"
                fullWidth
                maxWidth={false}
                PaperProps={{ id: 'modalAmbientesTrabalho' }}
            >
                <CustomDialogTitle id="form-dialog-title">{habilitarInsercaoAtualizacao ? 'Incluir' : 'Editar'} Ambiente de trabalho</CustomDialogTitle>
                <CustomDialogContent>
                    <Fieldset spacing={4}>
                        <VepSelect
                            accessor="itemAmbienteTrabalhoAuxiliar.localAmbiente"
                            label="Qual o tipo de estabelecimento do ambiente de trabalho?"
                            model={props.modelo}
                            setModel={props.setModelo}
                            xs={12} md={6}
                            required
                            {...regraValidacaoFormulario['itemAmbienteTrabalhoAuxiliar.localAmbiente'].obterPropriedadesValidacao()}
                            onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'itemAmbienteTrabalhoAuxiliar.localAmbiente': true })}
                        />

                        <VepTextField
                            accessor="itemAmbienteTrabalhoAuxiliar.descricaoSetor"
                            label="Descreva o local onde o trabalhador exerce suas atividades"
                            model={props.modelo}
                            setModel={props.setModelo}
                            xs={12} md={8}
                            multiline
                            rows={2}
                            required
                            {...regraValidacaoFormulario['itemAmbienteTrabalhoAuxiliar.descricaoSetor'].obterPropriedadesValidacao()}
                            onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'itemAmbienteTrabalhoAuxiliar.descricaoSetor': true })}
                        />

                        <VepSelect
                            accessor="itemAmbienteTrabalhoAuxiliar.tipoInscricaoAmbiente"
                            label="Tipo de inscrição da empresa contratante"
                            model={props.modelo}
                            setModel={props.setModelo}
                            xs={12} md={5}
                            required
                            {...regraValidacaoFormulario['itemAmbienteTrabalhoAuxiliar.tipoInscricaoAmbiente'].obterPropriedadesValidacao()}
                            onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'itemAmbienteTrabalhoAuxiliar.tipoInscricaoAmbiente': true })}
                        />

                        <CnpjAlfanumerico
                            accessor="itemAmbienteTrabalhoAuxiliar.numeroInscricaoAmbiente"
                            label="Número de inscrição"
                            model={props.modelo}
                                value={props.modelo.itemAmbienteTrabalhoAuxiliar.numeroInscricaoAmbiente.valor}
                                onChange={(e) => handleChangeNumeroInscricaoAmbiente(e)}
                            xs={12} md={3}
                            required
                            maskPattern={obterMascaraPorTipoInscricao(props.modelo.itemAmbienteTrabalhoAuxiliar.tipoInscricaoAmbiente.valor)}
                            maxLength={getStringValue(obterMascaraPorTipoInscricao(props.modelo.itemAmbienteTrabalhoAuxiliar.tipoInscricaoAmbiente.valor)).length}
                            {...regraValidacaoFormulario['itemAmbienteTrabalhoAuxiliar.numeroInscricaoAmbiente'].obterPropriedadesValidacao()}
                            onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'itemAmbienteTrabalhoAuxiliar.numeroInscricaoAmbiente': true })}
                        />
                    </Fieldset>
                </CustomDialogContent>
                <CustomDialogActions>
                    <Button variant="text" color="secondary" onClick={() => cancelar()}>
                        Cancelar
                    </Button>
                    <Button variant="text" color="primary" onClick={() => atualizarItem()}>
                        Salvar
                    </Button>
                </CustomDialogActions>
            </Dialog>

            {/*Modal para consulta de ambiente de trabalho*/}
            <Dialog
                open={props.somenteVisualizacao && habilitarVisualizacao}
                onClose={() => { cancelar() }}
                aria-labelledby="form-dialog-title"
                fullWidth
                maxWidth={false}
            >
                <CustomDialogTitle id="form-dialog-title">Visualizar Ambiente de Trabalho</CustomDialogTitle>
                <CustomDialogContent>
                    <div>
                        <List>
                            <Display show={props.modelo.itemAmbienteTrabalhoAuxiliar.localAmbiente != null && props.modelo.itemAmbienteTrabalhoAuxiliar.localAmbiente.valor != null}>
                                <ListItem>
                                    <ListItemText primary={props.modelo.itemAmbienteTrabalhoAuxiliar.localAmbiente.rotulo} secondary={props.modelo.itemAmbienteTrabalhoAuxiliar.localAmbiente.fonteDados[props.modelo.itemAmbienteTrabalhoAuxiliar.localAmbiente.valor]} />
                                </ListItem>
                            </Display>
                            <Display show={props.modelo.itemAmbienteTrabalhoAuxiliar.descricaoSetor != null && props.modelo.itemAmbienteTrabalhoAuxiliar.descricaoSetor.valor != null}>
                                <ListItem>
                                    <ListItemText primary={props.modelo.itemAmbienteTrabalhoAuxiliar.descricaoSetor.rotulo} secondary={props.modelo.itemAmbienteTrabalhoAuxiliar.descricaoSetor.valor} />
                                </ListItem>
                            </Display>
                            <Display show={props.modelo.itemAmbienteTrabalhoAuxiliar.tipoInscricaoAmbiente != null && props.modelo.itemAmbienteTrabalhoAuxiliar.tipoInscricaoAmbiente.valor != null}>
                                <ListItem>
                                    <ListItemText primary={props.modelo.itemAmbienteTrabalhoAuxiliar.tipoInscricaoAmbiente.rotulo} secondary={props.modelo.itemAmbienteTrabalhoAuxiliar.tipoInscricaoAmbiente.fonteDados[props.modelo.itemAmbienteTrabalhoAuxiliar.tipoInscricaoAmbiente.valor]} />
                                </ListItem>
                            </Display>
                            <Display show={props.modelo.itemAmbienteTrabalhoAuxiliar.numeroInscricaoAmbiente != null && props.modelo.itemAmbienteTrabalhoAuxiliar.numeroInscricaoAmbiente.valor != null}>
                                <ListItem>
                                    <ListItemText primary={props.modelo.itemAmbienteTrabalhoAuxiliar.numeroInscricaoAmbiente.rotulo} secondary={props.modelo.itemAmbienteTrabalhoAuxiliar.numeroInscricaoAmbiente.valor} />
                                </ListItem>
                            </Display>
                        </List>
                    </div>
                </CustomDialogContent>
                <CustomDialogActions>
                    <Button variant="text" color="secondary" onClick={() => cancelar()}>
                        Voltar
                    </Button>
                </CustomDialogActions>
            </Dialog>
        </Fragment>
    );
}

export default AmbientesTrabalho;
